/**
 * Default properties for Vantiv Provider.
 */
export const initVantivProviderProps = {
  MID: '',
  eprotectUrl: '',
  iframeSrc: '',
  iframeSrcV4: '',
  eprotectApi3Library: '',
  merchantTxnId: '',
  orderId: '',
  paypageId: '',
  reportGroup: '',
  transactionId: '',
};

/**
 * Initial submit data for Vantiv transactions.
 */
export const initVantivSubmitData = {
  id: '',
  orderId: '',
};
